var _path, _g, _path2, _g2, _path3, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirhome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2645_2841",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 12,
    width: 21,
    height: 6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8123 15.8075C19.303 13.3869 15.9525 12.0342 12.466 12.0342C8.97944 12.0342 5.6289 13.3869 3.11964 15.8075C2.95737 15.988 2.86932 16.2231 2.87317 16.4657C2.87701 16.7084 2.97246 16.9406 3.14037 17.1158C3.30828 17.291 3.53623 17.3963 3.77849 17.4104C4.02075 17.4246 4.25941 17.3466 4.44659 17.1922C6.59817 15.1124 9.47355 13.9499 12.466 13.9499C15.4584 13.9499 18.3338 15.1124 20.4853 17.1922C20.6636 17.364 20.9013 17.4604 21.1488 17.4614C21.2783 17.4609 21.4064 17.4342 21.5254 17.383C21.6444 17.3318 21.7518 17.2571 21.8411 17.1633C22.0165 16.9794 22.1118 16.7335 22.1064 16.4795C22.101 16.2254 21.9953 15.9838 21.8123 15.8075Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2645_2841)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.85913,
    y: 11.9854,
    width: 19.7574,
    height: 5.46169,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2645_2841",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 14,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4922 16.8365C11.3308 16.8373 10.1815 17.0718 9.1127 17.5261C8.04388 17.9803 7.07743 18.6451 6.27093 19.4808C6.18317 19.5736 6.11455 19.6828 6.06899 19.8021C6.02343 19.9214 6.00181 20.0486 6.00539 20.1762C6.00896 20.3039 6.03764 20.4297 6.0898 20.5463C6.14197 20.6629 6.21658 20.768 6.30939 20.8558C6.49683 21.033 6.747 21.1286 7.00487 21.1213C7.13256 21.1178 7.25828 21.0891 7.37488 21.0369C7.49148 20.9848 7.59666 20.9101 7.68442 20.8173C8.3123 20.1659 9.06507 19.6477 9.89775 19.2938C10.7304 18.9399 11.6259 18.7575 12.5307 18.7575C13.4354 18.7575 14.3309 18.9399 15.1636 19.2938C15.9962 19.6477 16.749 20.1659 17.3769 20.8173C17.466 20.9082 17.5722 20.9805 17.6893 21.03C17.8065 21.0795 17.9324 21.1053 18.0596 21.1058C18.2475 21.1051 18.4311 21.0493 18.5877 20.9454C18.7442 20.8415 18.8669 20.694 18.9406 20.5211C19.0142 20.3483 19.0356 20.1576 19.0021 19.9727C18.9686 19.7878 18.8816 19.6168 18.7519 19.4808C17.9409 18.6404 16.9683 17.973 15.8925 17.5185C14.8167 17.0641 13.66 16.8321 12.4922 16.8365Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2645_2841)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.0494,
    height: 4.76523,
    transform: "matrix(-1 0 0 1 19.061 16.7876)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2645_2841",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.49939 10.8108C0.49939 11.165 0.49939 11.3434 0.611226 11.398C0.723063 11.4526 0.864189 11.3447 1.14378 11.1251L10.8469 3.57876C11.6324 2.96766 12.0252 2.66277 12.4819 2.66277C12.9385 2.66277 13.3313 2.96899 14.1168 3.57876L23.8199 11.1251C24.0995 11.3434 24.2407 11.4526 24.3525 11.398C24.4643 11.3434 24.4643 11.165 24.4643 10.8108V10.2663C24.4643 9.62725 24.4643 9.30772 24.3285 9.03079C24.1927 8.75386 23.9411 8.55681 23.4365 8.16539L14.1168 0.915993C13.3313 0.304887 12.9385 0 12.4819 0C12.0252 0 11.6324 0.306218 10.8469 0.915993L1.52722 8.16539C1.02262 8.55681 0.769661 8.75386 0.635191 9.03079C0.500721 9.30772 0.49939 9.62725 0.49939 10.2663V10.8108Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2645_2841)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.513184,
    width: 23.9361,
    height: 11.3999,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirhome);
export default __webpack_public_path__ + "static/media/airhome.c60cd0f069955b38d7b63958afb2da46.svg";
export { ForwardRef as ReactComponent };